export default [
  {
    path: "/is_giris_cikis_tanimlari",
    name: "is_giris_cikis_tanimlari",
    component: () => import("./index.vue"),
    meta: {
      pageTitle: "is_giris_cikis_takip.İş Giriş/Çıkış Tanımları",
      breadcrumb: [
        {
          title: "Personel",
        },
        {
          title: "is_giris_cikis_takip.İş Giriş/Çıkış Tanımları",
          active: true,
        },
      ],
    },
  },
]
